import { render, staticRenderFns } from "./instApproveDemandDefault.vue?vue&type=template&id=43cda378&scoped=true"
import script from "./instApproveDemandDefault.vue?vue&type=script&lang=js"
export * from "./instApproveDemandDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cda378",
  null
  
)

export default component.exports